import fetch from "isomorphic-fetch";

import { handleError } from "@lib/utils/error";

import { withAccountAuthHeaders } from "./apiHelpers";
import { apiConf } from "./index";

export type GetNumberOfAttendancesResponse = {
    count: number;
};
export async function getNumberOfAttendances(): Promise<GetNumberOfAttendancesResponse> {
    try {
        const resp = await fetch(
            withAccountAuthHeaders(`${apiConf.BACK_URL}/v1/attendances/to_validate/count`),
        );

        if (resp.status >= 400) {
            handleError(await resp.json(), resp.status);
            return Promise.reject(new Error("getNumberofAttendances"));
        }
        const json = await resp.json();
        return json;
    } catch (e) {
        handleError(e, 500);
        return Promise.reject(new Error("getNumberofAttendances"));
    }
}
